import React from 'react';
import Loadable from 'react-loadable';
import {
    Route,
    IndexRoute
} from 'react-router';

import { getCookie } from '@client/helpers/cookie';
import { NEW_API_FLAG, NEW_API_FLAG_ACTIVE_VALUE } from '@shared/flags';

import CoreLayout from '../layouts/core/index';
import GuestLayout from '../layouts/guest';
import MyLoungeLegacy from '../views/mylounge-legacy';
import MyLounge from '../views/mylounge';
import Help from '../views/Help';

import { getIsLoggedIn } from '../redux/modules/customer/selectors';

const LoadablePrivacyPage = Loadable({
    loader: () => import(/* webpackChunkName: "privacy-component" */'../views/Privacy'),
    loading: () => '',
});

/* eslint-disable no-multi-spaces */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */

// params in parenthesis are optional
export default (store, options) => {
    const state = store.getState();
    const isLoggedIn = getIsLoggedIn(state);

    const isNewApi = getCookie(NEW_API_FLAG) === NEW_API_FLAG_ACTIVE_VALUE;

    const MyloungeComponent = isNewApi ? MyLounge : MyLoungeLegacy;

    return (
        <Route>
            <Route component={CoreLayout} path="/">
                <IndexRoute component={MyloungeComponent} />
                {/* TODO: change :filterTag to :categoryId */}
                <Route component={MyloungeComponent} path="/event(/:filterTag)" props={{ ...options }} />
            </Route>
            <Route component={isLoggedIn ? CoreLayout : GuestLayout}>
                <Route path="/default/cms/*" component={MyloungeComponent} />
                <Route path="/myaccount*" component={MyloungeComponent} />
                <Route path="/lp/*" component={MyloungeComponent} />
                <Route
                    component={Help}
                    path="/help"
                />
                <Route
                    component={() => <LoadablePrivacyPage isGuest={!isLoggedIn} />}
                    path="/privacy"
                />
                <Route
                    component={() => <LoadablePrivacyPage isGuest={!isLoggedIn} />}
                    path="/privacy/app"
                />
            </Route>
        </Route>
    );
};
